<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="仓号">
                                <el-input style="width: 180px" v-model="warehouseNo" placeholder="双击选择仓库" @click.native="selWareHouse">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="物资类别">
                                <el-input style="width: 180px" v-model="typeName" placeholder="输入物资类别" >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="系列号">
                                <el-input style="width: 180px" v-model="serialNo" placeholder="输入系列号" >
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="物资编码">
                                <el-input style="width: 180px" v-model="proCode" placeholder="双击选择物资编码" >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="物资名称">
                                <el-input style="width: 180px" v-model="proName" placeholder="双击选择物资名称" >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="供应商">
                                <el-input style="width: 180px" v-model="supplierName" placeholder="双击选择供应商" @click.native="selSupplier">
                                </el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="选项">
                                <el-radio v-model="endNum" :label="0" border size="medium"> 库存数量 = 0 </el-radio>
                                <el-radio v-model="endNum" :label="1" border size="medium"> 库存数量 ≠ 0 </el-radio>
                                <el-radio v-model="endTotal" :label="0" border size="medium"> 库存金额 = 0 </el-radio>
                                <el-radio v-model="endTotal" :label="1" border size="medium"> 库存金额 ≠ 0 </el-radio>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
        <selWareHouse v-if="showWareHouse"
                      :warehouseId="warehouseId"
                      @closeDialog="closeDialog"
                      @checkRow="checkWareHouse">
        </selWareHouse>
        <selSupplier v-if="showSupplier"
                     :roleData="supplierName"
                     @closeDialog="closeDialog"
                     @checkRow="checkSupplier">
        </selSupplier>
    </div>
</template>

<script>
    import selWareHouse from '@/components/page/stock/warehouse/selWareHouse'
    import selSupplier from '@/components/page/supplier/supplier/selSupplier'

    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            selWareHouse,selSupplier
        },
        data() {
            return {
                btnList: [],
                searBarHeight: 70,
                productInfoId:"",
                serialNo:"",
                proCode:"",
                proName:"",
                typeName:"",
                showProduct:false,

                warehouseId:"",
                warehouseNo:"",
                showWareHouse:false,
                endNum:"",
                endTotal:"",
                showSupplier:false,
                supplierId:"",
                supplierName:"",
            }
        },
        async mounted() {
        },
        methods: {
            closeDialog() {
                this.showWareHouse = false;
                this.showSupplier = false;
            },
            selWareHouse(){
                this.showWareHouse = true;
            },
            checkWareHouse(row) {
                this.warehouseId = row.warehouseId;
                this.warehouseNo = row.warehouseNo;
                this.showWareHouse = false;
            },
            selSupplier(){
                this.showSupplier = true;
            },
            checkSupplier(row) {
                this.supplierId = row.supplierId;
                this.supplierName = row.supplierName;
                this.showSupplier = false;
            },
            search() {

                let searchData = {
                    warehouseNo:this.warehouseNo,
                    typeName:this.typeName,
                    serialNo:this.serialNo,
                    proCode:this.proCode,
                    proName:this.proName,
                    endNum:this.endNum,
                    endTotal:this.endTotal,
                    supplierName:this.supplierName
                }
                this.$emit('search',searchData);
            },
            excel() {

                let searchData = {
                    warehouseNo:this.warehouseNo,
                    typeName:this.typeName,
                    serialNo:this.serialNo,
                    proCode:this.proCode,
                    proName:this.proName,
                    endNum:this.endNum,
                    endTotal:this.endTotal,
                    supplierName:this.supplierName
                }
                this.$emit('excel',searchData);
            },
            doBtn(type) {
                this.$emit('doBtn', type)
            },
        }
    }
</script>
